import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

// For Encryption
import SecureLS from "secure-ls";

var ls = new SecureLS({ isCompression: false });

import modules from "./modules";

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  plugins: [
    createPersistedState({
      key: "spd_pos",
      // storage: {
      //   getItem: (key) => ls.get(key),
      //   setItem: (key, value) => ls.set(key, value),
      //   removeItem: (key) => ls.remove(key),
      // },
    }),
  ],
  strict: process.env.NODE_ENV !== "production",
  actions: {
    fetchAllData({ dispatch }) {
      dispatch("auth/fetchUserInfo");

    },
  },
});
